export const MANAGE_REWARDS_API_ENDPOINTS = {
  GET_BADGES: 'api/v1/icons',
  GET_BADGE_TYPES: 'api/v1/badge/types',
  CREATE_BADGE: 'api/v1/badges',
  GET_EMPLOYEE_LEVELS: 'api/v1/employees/level',
  GET_EMPLOYEE_PAY_TYPE: 'api/v1/employees/pay-type',
  GET_BADGE_DETAILS: 'api/v1/badges/',
  UPDATE_BADGE: 'api/v1/badges/',
  GET_BADGES_LIST: 'api/v1/badges',
  GET_AUTOMATION_RULE: 'api/v1/badges/automationrule'
}

export const typeMap = {
  NOMINATED: '2d05cd35-12dd-4c6e-b099-5221e026d680',
  PEERTOPEER: '75b30c17-5617-4103-b781-d62b1d8a3fa7',
  AUTOMATED: '449e1150-ddac-485d-8321-537705c5bb40'
}
export const iconMap = {
  SEEDLING: "91d67871-c256-455b-b636-e7e1e5a86cb7",
  BRAIN: "1035437b-17fd-40db-8a3a-3a5863595760",
  HOUSE: "13a388b1-135f-4aa1-b745-348153320c75",
  BOOK: "fea35862-0de0-4b89-982b-aea086f7a963",
  BULLSEYE: "91fa7de4-a0b6-44a8-a53b-19654225c8b1",
  KEY: "cc92b7b0-5556-40b2-bbcb-b6b953095419",
  THUMBTACK: "1ae03357-3e02-4fc5-aa67-84c8a2ef9fdf",
  BULLHORN: "2767209a-8553-454e-a8eb-788f522a2ab2",
  GEARS: "8350bdee-5534-406d-96ca-c070a8cc8827",
  GEM: "20645554-9a30-43a7-aabc-1145289a26fd",
  STOPWATCH: "57d2df60-9302-4d9b-9e10-61507d120e5b",
  FLASK: "6f010f83-6319-47a4-9d76-edad1bf1a3eb",
  SUN: "54f33d37-ba1d-45a9-adbb-5df5ed907f9d",
  ANCHOR: "7a8d6af9-f510-4d08-b424-4a322f874539",
  MOUNTAIN: "80c71964-8d6d-42b1-aa4c-19efee4e7432",
  NETWORK_WIRED: "3c6c18b2-1b4d-4f19-b9ec-a74c1c48f3fa",
  CHART_LINE: "c5f2c137-2ae3-4048-96f8-349db4b1a96e",
  FACE_SMILE: "c54d06a4-06e6-4d75-8a4a-af51626a1299",
  MAGNIFYING_GLASS: "38d24467-7f0e-4418-95cc-cd3486639a5e",
  CHAMPAGNE_GLASSES: "bda0ad3e-d5e4-45a2-99b6-74d8fcc88055",
  SCREWDRIVER_WRENCH: "5289e694-a296-415e-ae30-baa4876a8378",
  CHALKBOARD_USER: "a4110de3-da50-4d06-81a8-bf119227e53e",
  SUITCASE_MEDICAL: "36e27cc0-98ad-4b3f-a73c-827811ab7860",
  BOOK_OPEN_READER: "44916175-23cc-46de-98c6-0902327e81b9",
  SHIELD_HALVED: "92e8ffb4-d90e-45c6-8ccd-ecaef3bd5141",
  GRADUATION_CAP: "c8010b5e-2588-40db-ad73-1a9e6f8e1f40",
  FLAG_CHECKERED: "6dcaf639-b7d6-48fb-a41e-167ffd7c0156",
  BINOCULARS: "b09fd806-a949-4b46-a586-18d5cee6a227",
  PEOPLEPULLING: "abf3ede4-f9a5-40f5-b3ff-e26624dc2d1f",
  PEOPLECARRYING: "b7f38f46-d835-4a7a-bf41-d75ab1d1e19b",
  MUG: "c4794131-7cb5-46ac-87cb-b6b7be3eb3a5",
  BELL: "c5cd07ae-d6b1-4ec4-8ae1-d0faa9595221",
  PEN: "1b35eff8-34ad-45c7-ba94-166f5966acb8",
  TICKET: "69c1e5bc-3212-421a-b81d-1256a710983c",
  RIBBON: "3242992f-f8fc-4d4c-9b23-4d1a5ec6da5b",
  CERTIFICATE: "bea87261-70a6-47da-b4da-3dc5042cf478",
  CAKE_CANDLES: "09c73d48-ddef-4f5e-b2c2-29ecc8887c4d",
  LIGHTBULB: "01f7790e-e7da-4ea3-806f-f9459bf2565b",
  HANDPLUS: "250af36e-c073-4140-9967-659558e96fdd",
  GIFT: "4a20bb22-3faa-4fcc-9e8b-e507c22ae904",
  AWARD: "962a7220-5c4d-4730-bea0-e56e9f9fb9ac",
  STAR: "a68a23d6-4543-443c-b6fe-f12ac810cedf",
  WAND: "a6a56a9b-54ea-4971-a5be-26f442f8c5ca",
  CALENDAR: "8d5800dd-97c6-4117-868a-950d4097cc48",
  THUMBSUP: "3b2a3eb3-7a1b-4b3f-b585-08a84d3364c7",
  HANDSHAKE: "663f098c-f49c-4384-ad6f-f59f15abc026",
  USERS: "6711677e-832c-444e-868d-7f0b62274e61",
  HEART: "7252331b-e81f-4c41-a57b-fd762bc617b9",
  TROPHY: "741c3ac4-c5a5-41ec-b9fb-b0c42a0f3b73",
  PUZZLE: "7b3eea86-a180-4846-ad04-25e5088c7847",
  FIRE: "7c1dbb3f-67e6-45df-8924-54af00fa1933",
  ROCKET: "89882e76-ea17-4ceb-b169-b0bc56c249c8",
  DUMBELL: "a75409c4-fe4c-417a-b506-77f67313d891",
  PIPERHAT: "c5cd07ae-d6b1-4ec4-8ae1-d0faa9595221",
  BOLT: "c98f6802-c79b-4d32-a13b-b65fc19d7258",
  COMMENTS: "cc4c300f-99ca-4f91-ac4f-14c12511a2c3",
  WRENCH: "d2b33bdd-f090-42ad-bb2a-432f6bcc615b",
  CROWN: "f12b7223-b2f3-4351-95d8-c7f218e71657",
  MEDAL: "f45916fc-b22a-4304-8b01-687adfd0ce96",
  HANDHEART: "f734ab47-7f05-43c1-ae4b-92a806b91726",
  BRUSH: "fcdb094a-a59c-41d4-a540-293c80f1ccd1",
  RECEIVED: "361135d1-3529-4079-a066-153d67a121e6",
  TESTBONUS: "55182499-920a-493d-b623-f2f3df18dbde",
  SEND: "84622c44-7e1d-4b54-92f6-e075b7130404",
};